import { getLocale } from "../runtime";

const sv_left = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `kvar`
};

const left = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_left(inputs)
	return "left";
};

export { left as "left" };